<lib-dialog>
  <div class="formato-contable-dialog">
    <div class="dialog-header">
      <h3 class="dialog-title">{{ isEditMode ? 'Editar' : 'Nuevo' }} Formato Contable</h3>
      <button
        type="button"
        class="close-btn"
        (click)="onCancel()"
        [disabled]="loading()"
        aria-label="Cerrar"
      >
        ✕
      </button>
    </div>

    @if (mostrarAlerta()) {
      <div class="alert-container">
        <lib-alert
          [type]="alertaTipo()"
          [title]="alertaTitulo()"
          [message]="alertaMensaje()"
          [autoClose]="false"
          [closeButton]="true"
          (closed)="cerrarAlerta()"
        ></lib-alert>
      </div>
    }

    <div class="dialog-content">
      <form [formGroup]="formatoForm">
        <div class="two-column-grid">
          <div class="form-field-wrapper">
            <lib-field-label
              label="Código Formato"
              [required]="true"
              tooltip="Código alfanumérico único del formato (máx. 10 caracteres)"
            />
            <div class="input-search-group">
              <lib-input
                [formControl]="codigoFormatoControl"
                placeholder="Seleccione usando el botón de búsqueda"
                [errorMsg]="getError('codigoFormato')"
                [maxLength]="10"
                [showCharCount]="true"
                [class.disabled-field]="true"
              >
              </lib-input>
              <lib-icon
                name="Search"
                (click)="buscarFormato()"
                class="cursor-pointer search-icon"
                [class.disabled]="loading() || isEditMode"
              ></lib-icon>
            </div>
            <div class="search-loading" *ngIf="searching()">
              <span class="spinner"></span>
              <span class="search-text">Buscando...</span>
            </div>
          </div>

          <div class="form-field-wrapper">
            <lib-field-label
              label="Nombre Formato"
              tooltip="Nombre del formato cargado automáticamente"
            />
            <lib-input
              [formControl]="nombreFormatoControl"
              placeholder="Se cargará automáticamente"
              [showCharCount]="true"
              [maxLength]="50"
            >
            </lib-input>
          </div>
        </div>

        <div class="two-column-grid">
          <div class="form-field-wrapper">
            <lib-field-label
              label="Cod. Centro Costo"
              [required]="requiereCentroCosto()"
              tooltip="Código del centro de costo. Se habilita si el formato no tiene distribución por centro de costo."
            />
            <div class="input-search-group">
              <lib-input
                [formControl]="codigoCentroCostoControl"
                placeholder="Seleccione usando el botón de búsqueda"
                [errorMsg]="getError('codigoCentroCosto')"
                [maxLength]="10"
                [showCharCount]="true"
                [class.disabled-field]="codigoCentroCostoControl.disabled"
              >
              </lib-input>
              <lib-icon
                name="Search"
                (click)="buscarCentroCosto()"
                class="cursor-pointer search-icon"
                [class.disabled]="loading() || isEditMode || !centroCostoHabilitado()"
              ></lib-icon>
            </div>
          </div>

          <div class="form-field-wrapper">
            <lib-field-label
              label="Nombre Centro Costos"
              tooltip="Nombre del centro de costo cargado automáticamente"
            />
            <lib-input
              [formControl]="nombreCentroCostoControl"
              placeholder="Se cargará automáticamente"
              [maxLength]="100"
              [showCharCount]="true"
            >
            </lib-input>
          </div>
        </div>

        <div class="two-column-grid">
          <div class="form-field-wrapper">
            <lib-field-label
              label="Valor Base"
              [required]="true"
              tooltip="Valor base del formato contable (Total Antes de Impuesto)"
            />
            <lib-input
              [formControl]="valorBaseControl"
              type="text"
              inputmode="decimal"
              placeholder="0,00"
              [maxLength]="15"
              [showCharCount]="true"
              [errorMsg]="getError('valorBase')"
              (focus)="onValorFocus(valorBaseControl)"
              (blur)="onValueBlur(valorBaseControl)"
            />
          </div>

          <div class="form-field-wrapper">
            <lib-field-label
              label="Valor Amortizar"
              [required]="valorAmortizarRequerido()"
              tooltip="Valor a amortizar. Se habilita si el formato tiene cuenta de amortización de anticipo."
            />
            <lib-input
              [formControl]="valorAmortizarControl"
              type="text"
              inputmode="decimal"
              placeholder="0,00"
              [maxLength]="15"
              [showCharCount]="true"
              [errorMsg]="getError('valorAmortizar')"
              (focus)="onValorFocus(valorAmortizarControl)"
              (blur)="onValueBlur(valorAmortizarControl)"
            />
          </div>
        </div>

        <div class="form-field-wrapper">
          <lib-field-label
            label="Valor Impuesto"
            [required]="valorImpuestoRequerido()"
            tooltip="Valor del impuesto aplicado. Solo se habilita si el tercero tiene régimen Ordinario."
          />
          <lib-input
            [formControl]="valorImpuestoControl"
            type="text"
            inputmode="decimal"
            placeholder="0,00"
            [maxLength]="15"
            [showCharCount]="true"
            [errorMsg]="getError('valorImpuesto')"
            (focus)="onValorFocus(valorImpuestoControl)"
            (blur)="onValueBlur(valorImpuestoControl)"
          />
        </div>

        <div class="form-field-wrapper">
          <lib-field-label
            label="Valor Total"
            [required]="true"
            tooltip="Valor total (Base + Impuesto) - Campo bloqueado"
          />
          <lib-input
            [formControl]="valorTotalControl"
            type="text"
            [maxLength]="15"
            [showCharCount]="true"
            placeholder="0,00"
            [errorMsg]="getError('valorTotal')"
          >
          </lib-input>
        </div>
      </form>
    </div>

    <div class="dialog-footer">
      <div class="actions">
        <lib-button variant="secondary" type="button" [disabled]="loading()" (clicked)="onCancel()">
          Cancelar
        </lib-button>
        <lib-button
          variant="primary"
          type="button"
          [disabled]="loading() || !guardarHabilitado()"
          (clicked)="onSave()"
        >
          {{ loading() ? 'Procesando...' : 'Guardar' }}
        </lib-button>
      </div>
    </div>
  </div>
</lib-dialog>
